export const ERROR_RESPONSE = "ERROR_RESPONSE";
export const RESET_RESPONSE_POLICY = "RESET_RESPONSE_POLICY"
